/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  ApproveWithdrawalOptions,
  ApproveWithdrawalStatus200,
  ApproveWithdrawalStatus400,
  ApproveWithdrawalStatus401,
  ApproveWithdrawalStatus403,
  ApproveWithdrawalStatus404,
  ApproveWithdrawalStatus409,
  ApproveWithdrawalStatus500,
} from '../types/ApproveWithdrawal'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { approveWithdrawal } from '../clients/approveWithdrawal'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const approveWithdrawalMutationKey = () =>
  [{ url: '/v1/web3/admin/withdrawals/:withdrawal_id/approve' }] as const

export function approveWithdrawalMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = approveWithdrawalMutationKey()
  return mutationOptions<
    ApproveWithdrawalStatus200,
    ResponseErrorConfig<
      | ApproveWithdrawalStatus400
      | ApproveWithdrawalStatus401
      | ApproveWithdrawalStatus403
      | ApproveWithdrawalStatus404
      | ApproveWithdrawalStatus409
      | ApproveWithdrawalStatus500
    >,
    ApproveWithdrawalOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path }) => {
      return approveWithdrawal({ ...config, path, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Approves a PENDING withdrawal, stamping approved_by/approved_at and transitioning it to APPROVED_WITHOUT_FEE. The reserved funds stay reserved; there is no ledger change. Approval does not by itself make the withdrawal eligible for on-chain submission by the withdrawal daemon: no fee has been quoted or locked at this point, and only fee-locked (APPROVED) withdrawals are submittable. Only PENDING withdrawals may be approved, so a repeated approval returns 409 rather than approving twice. An APPROVED_WITHOUT_FEE withdrawal may still be rejected, which releases its reservation.
 * @summary Approve a pending USDC withdrawal (admin)
 * {@link /v1/web3/admin/withdrawals/:withdrawal_id/approve}
 */
export function useApproveWithdrawal<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ApproveWithdrawalStatus200,
      ResponseErrorConfig<
        | ApproveWithdrawalStatus400
        | ApproveWithdrawalStatus401
        | ApproveWithdrawalStatus403
        | ApproveWithdrawalStatus404
        | ApproveWithdrawalStatus409
        | ApproveWithdrawalStatus500
      >,
      ApproveWithdrawalOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? approveWithdrawalMutationKey()

  const baseOptions = approveWithdrawalMutationOptions(config) as UseMutationOptions<
    ApproveWithdrawalStatus200,
    ResponseErrorConfig<
      | ApproveWithdrawalStatus400
      | ApproveWithdrawalStatus401
      | ApproveWithdrawalStatus403
      | ApproveWithdrawalStatus404
      | ApproveWithdrawalStatus409
      | ApproveWithdrawalStatus500
    >,
    ApproveWithdrawalOptions,
    TContext
  >

  return useMutation<
    ApproveWithdrawalStatus200,
    ResponseErrorConfig<
      | ApproveWithdrawalStatus400
      | ApproveWithdrawalStatus401
      | ApproveWithdrawalStatus403
      | ApproveWithdrawalStatus404
      | ApproveWithdrawalStatus409
      | ApproveWithdrawalStatus500
    >,
    ApproveWithdrawalOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ApproveWithdrawalStatus200,
    ResponseErrorConfig<
      | ApproveWithdrawalStatus400
      | ApproveWithdrawalStatus401
      | ApproveWithdrawalStatus403
      | ApproveWithdrawalStatus404
      | ApproveWithdrawalStatus409
      | ApproveWithdrawalStatus500
    >,
    ApproveWithdrawalOptions,
    TContext
  >
}
